import { getVar } from "./less-vars";

const MESSAGE_DURATION = parseInt(getVar("message-dismiss-duration"), 10);

const LEVEL_ERROR = "danger";
const LEVEL_WARN = "warning";
const LEVEL_INFO = "info";
const LEVEL_SUCCESS = "success";

const LEVEL_WEIGHTS = {
  [LEVEL_ERROR]: 0,
  [LEVEL_WARN]: 10,
  [LEVEL_INFO]: 20,
  [LEVEL_SUCCESS]: 30,
};

// Filter any message matching the following status codes.
// 401 result in auth logout so there is no case where we
// display a message to the user.
const MESSAGE_AUTH_CODES = [401];

export {
  LEVEL_ERROR,
  LEVEL_WARN,
  LEVEL_SUCCESS,
  LEVEL_INFO,
  LEVEL_WEIGHTS,
  MESSAGE_AUTH_CODES,
  MESSAGE_DURATION,
};
